import { Banner } from '@/ui'
import { refusalOf } from '../../model/pack/refusal'

export function RefusalBanner({ error, title }: { error: unknown; title?: string }) {
  if (!error) return null
  const r = refusalOf(error)
  return (
    <Banner tone="error" title={title ?? r.title}>
      {title && <p>{r.title}</p>}
      {r.lines.length > 0 && (
        <ul className="mt-1 list-disc pl-5 text-[14px] text-ink">
          {r.lines.map((l, i) => (
            <li key={i}>{l}</li>
          ))}
        </ul>
      )}
    </Banner>
  )
}
